import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {
    createKhanmigoCheckoutStripeSession as CreateStripeSessionResponse,
    createKhanmigoCheckoutStripeSessionVariables as CreateStripeSessionVariables,
} from "./__graphql-types__/createKhanmigoCheckoutStripeSession.ts";

import type {} from "./__graphql-types__//index.ts";

// Mutation to create a stripe checkout session
export const CREATE_STRIPE_SESSION: GqlOperation<
    CreateStripeSessionResponse,
    CreateStripeSessionVariables
> = gqlOp(gql`
    mutation createKhanmigoCheckoutStripeSession(
        $priceID: String!
        $paymentFrequency: PaymentFrequency!
        $cancelURL: String!
        $successURL: String!
        $couponID: String
    ) {
        createStripeSession(
            priceID: $priceID
            paymentFrequency: $paymentFrequency
            cancelURL: $cancelURL
            successURL: $successURL
            couponID: $couponID
        ) {
            redirectURL
            error {
                code
                debugMessage
            }
        }
    }
`);
